<template>
  <div class="container" :style="containerStyle">
    <p v-if="!patientId">{{ tr('No patient is currently selected.') }}</p>
    <Suspense v-else>
      <template #default>
        <PatientSummary :patientId="patientId"/>
      </template>
      <template #fallback>
        <BaseSpinner class="base-spinner"/>
      </template>
    </Suspense>
    <div class="overlay" v-if="isDraggingToolId"></div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
// Copyright (c) 2023 datma, inc.
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import PatientSummary from './PatientSummary.vue'
import { computed, inject, ref } from 'vue'
import { useStore } from 'vuex'
import { themeColors } from '@/common/shared.js'
import BaseSpinner from '@/components/ui/icons/BaseSpinner.vue'

const tr = inject('tr')
const store = useStore()
const loadingStatus = ref('loading')

const patientId = computed(() => store.getters.session.patient.id)

const containerStyle = computed(() => ({
  backgroundColor: themeColors[store.getters.currentThemeName].modalBackgroundColor,
  display: loadingStatus.value === 'loading' ? 'flex' : null,
}))

</script>

<style lang="scss" scoped>
.container {
  position: static;
  width: 100%;
  height: 100%;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  overflow: auto;

  div.overlay {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
}

p {
  margin: auto;
  color: red;
  font-size: 1.5rem;
}

.base-spinner {
  margin-top: 2vmax;
  margin-left: 2vmax;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
}
</style>
